import { isObject } from 'lodash';

export const parseEntryValue = (value: any): any => {
  if(value === null) {
    return '';
  }

  const replaceSeparator = (str: any) => {
    if(str === '[object Object]') {
      return '';
    }
    return `${str}`.replace(/;/ig, ',');
  }

  if(!isObject(value)) {
    return replaceSeparator(value);
  }
  // @ts-ignore
  const { props, type } = value;

  // @ts-ignore
  switch(true) {
    case (!!props && props.hasOwnProperty('children') && Array.isArray(props.children)) :
      return props.children.map(parseEntryValue).filter((_val: any) => !!`${_val}`.trim()).join('');

    case (!!props && props.hasOwnProperty('children') && props.children.hasOwnProperty('props')) :
      return parseEntryValue(props.children);

    case (!!props && props.hasOwnProperty('children')) :
      return replaceSeparator(props.children.toString());

    case (type && type === 'br') :
      return ' ';

    case (Array.isArray(value)) :
      return value.map(parseEntryValue).join(' ');


    default :
      return '';
  }
}
